









































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IIssue, IUser } from '@/lib/interfaces';
import { EIssueStatus } from '@/lib/enums';
import { getAllIssuesInActiveSprints } from '@/services/api.service';
import Trello from '@/components/Trello.vue';
import { mapState } from 'vuex';
import { getCookie, setCookie } from '@/lib/helpers/common.helper';

@Component({
  components: {
    Trello,
  },
  sockets: {
    addToActiveSprint(this: ActiveSprints, issue: IIssue) {
      this.issues.push(issue);
    },
    deleteFromActiveSprint(this: ActiveSprints, issue: IIssue) {
      for (let i = 0; i < this.issues.length; i++) {
        if (this.issues[i]._id === issue._id) {
          this.issues.splice(i, 1);
          break;
        }
      }
    },
  },
  computed: mapState(['users']),
})
export default class ActiveSprints extends Vue {
  /** users from vuex */
  public users!: { string: IUser };

  /** Сгруппированные карточки по исполнителю */
  private get groupedIssues(): Map<string, IIssue[]> {
    const map = new Map<string, IIssue[]>();
    this.issues.forEach((issue) => {
      if (issue.member) {
        const possibleIssues = map.get(issue.member);
        if (!possibleIssues) {
          map.set(issue.member, [issue]);
        } else {
          possibleIssues.push(issue);
        }
      }
    });
    return map;
  }
  private issues: IIssue[] = [];
  private statuses: EIssueStatus[] = Object.values(EIssueStatus);

  /** Значение строки поиска */
  private searchText: string = '';
  /** Включена ли группировка по исполнителю */
  private groupByMember: boolean = getCookie('group_by_member') === 'true' || false;

  @Watch('groupByMember')
  private onGroupByMemberChanged(val: boolean, oldVal: boolean) {
    setCookie('group_by_member', val.toString());
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const issues: IIssue[] = await getAllIssuesInActiveSprints(to.params.project_id);

    next((vm: ActiveSprints) => {
      vm.issues = issues;
    });
  }
}
